import React, { useState } from 'react'

function BtnTabs({getId, idRef}) {
  const [btn, setBtn] = useState("")
  return (
    <div className="d-flex gap-2 items-center justify-content-center flex-wrap" style={{marginTop: "0px", marginBottom: "60px"}}>
    <a href={"#logo-design"} className='tab-btn' onClick={getId} >Logo Design</a>
    <a href={"#web-design"} className='tab-btn' onClick={getId} >Web Design</a>
    <a href={"#brand-design"} className='tab-btn' onClick={getId} >Brand Design</a>
    <a href={"#book-design"} className='tab-btn' onClick={getId} >Book Design</a>
    <a href={"#stationary-design"} className='tab-btn' onClick={getId} >Stationary</a>
    <a href={"#app-design"} className='tab-btn' onClick={getId} >App Design</a>
    <a href={"#business-advertizing"} className='tab-btn' onClick={getId} >Business Advertising</a>
    <a href={"#business-card"} className='tab-btn' onClick={getId} >Business Card</a>
  </div>
  )
}

export default BtnTabs